import { reactEvents } from "../../../../../bridge/reactEvents";
import { angularEvents } from "../../../../../bridge/angularEvents";

// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.articles.new', {
        url: '/new',
        views: {
            "wideColumnView@product": {
                templateUrl: 'main/product/articles/article/article.tpl.html',
                controller: 'ArticleController as vm'
            }
        },
        resolve: {
            itemGroups: itemGroupsResolver,
            articleCollections: articleCollectionsResolver,
            salesChannels: salesChannelsResolver,
            vats: vatsResolver,
            article: function () {
                return {};
            },
            articleTypes: articleTypesResolver,
            countries: countriesResolver,
            productClasses: productClassesResolver,
            currencies: currenciesResvolver,
            accounts: accountsResolver,
            defaultCurrency: defaultCurrencyResolver,
            searchTerms: searchTermsResolver,
            hasSimpleWms: hasSimpleWmsResolver,
            metaFieldValues: metaFieldValuesResolver,
            metaFields: metaFieldsResolver
        }
    });
    $stateProvider.state('product.articles.article', {
        url: '/{articleId}',
        views: {
            "wideColumnView@product": {
                templateUrl: 'main/product/articles/article/article.tpl.html',
                controller: 'ArticleController as vm'
            }
        },
        resolve: {
            article: articleResolver,
            articleCollections: articleCollectionsResolver,
            salesChannels: salesChannelsResolver,
            vats: vatsResolver,
            itemGroups: itemGroupsResolver,
            articleTypes: articleTypesResolver,
            countries: countriesResolver,
            productClasses: productClassesResolver,
            currencies: currenciesResvolver,
            accounts: accountsResolver,
            defaultCurrency: defaultCurrencyResolver,
            searchTerms: searchTermsResolver,
            hasSimpleWms: hasSimpleWmsResolver,
            metaFieldValues: metaFieldValuesResolver,
            metaFields: metaFieldsResolver
        }
    });
}

// @ngInject
function searchTermsResolver(ProductsApiService, $stateParams) {
    return {
        filter: $stateParams.filter,
        currentPage: $stateParams.currentPage,
        pageSize: $stateParams.pageSize,
        inactive: $stateParams.inactive,
        match: $stateParams.match
    };
}

// @ngInject
function articleResolver(ProductsApiService, $stateParams) {
    return ProductsApiService.getProduct($stateParams.articleId);
}

// @ngInject
function salesChannelsResolver(ProductsApiService) {
    return ProductsApiService.getSalesChannels();
}

// @ngInject
function itemGroupsResolver(ProductsApiService) {
    return ProductsApiService.getItemGroupFlats();
}

// @ngInject
function accountsResolver(AccountsApiService) {
    return AccountsApiService.getAccounts();
}

// @ngInject
function articleCollectionsResolver(ProductsApiService) {
    return ProductsApiService.getArticleCollections();
}

// @ngInject
function vatsResolver(VatsApiService) {
    return VatsApiService.getVats();
}

// @ngInject
function articleTypesResolver(ProductsApiService) {
    return ProductsApiService.getArticleTypes();
}

// @ngInject
function countriesResolver(ProductsApiService) {
    return ProductsApiService.getCountries();
}

// @ngInject
function productClassesResolver(ProductsApiService) {
    return ProductsApiService.getProductClasses();
}
// @ngInject
function currenciesResvolver(ProductsApiService) {
    return ProductsApiService.getCurrencies();
}
// @ngInject
function defaultCurrencyResolver(ProductsApiService) {
    return ProductsApiService.getDefaultCurrency();
}

// @ngInject
function hasSimpleWmsResolver(ProductsApiService) 
{
    return ProductsApiService.hasSimpleWms();
}

// @ngInject
function metaFieldValuesResolver(ProductsApiService, $stateParams) {
    if (!$stateParams.articleId) {
        return [];
    }
    return ProductsApiService.getMetaFieldValues($stateParams.articleId);
}

// @ngInject
function metaFieldsResolver(ProductsApiService, $stateParams) {
    if (!$stateParams.articleId) {
        return [];
    }
    return ProductsApiService.getMetaFields($stateParams.articleId);
}

// @ngInject
function ArticleController($q, $scope, $state, $rootScope, $translate, ProductsApiService, HelperService, loadSpinnerService, article, itemGroups, vats, articleCollections, ArticleLabelsPrintDialogService, ArticleChangeItemGroupDialogService, ProductService,
    ArticleNewIntrastatDialogService, articleTypes, AuthService, salesChannels, ToasterService, countries, productClasses, currencies, accounts, defaultCurrency, searchTerms, hasSimpleWms, metaFieldValues, metaFields, DS,
    colourChangeDialogService, GenericComponentService) {
    var vm = this;

    //Properties
    vm.environment = DS.defaults.ENV.NAME;
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.rowSupplierPricesData = [];
    vm.articleChangeCount = 0;
    vm.salesChannels = salesChannels;
    vm.intrastats = [];
    vm.accounts = accounts;
    vm.itemGroups = itemGroups;
    vm.articleCollections = articleCollections;
    vm.selectedArticle = article;
    vm.vats = vats;
    vm.selectedArticleCopy = angular.copy(vm.selectedArticle);
    vm.articleTypes = articleTypes;
    vm.selectedArticleVariantFilter = {};
    vm.selectedSupplierFilter = {};
    vm.supplierRowData = [];
    vm.isNewArticle = !article.id;
    vm.isEditing = vm.isNewArticle ? true : false;
    vm.filter = '';
    vm.currentPage = 1;
    vm.pageSize = 20;
    if (searchTerms) {
        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.currentPage = searchTerms.currentPage < 1 ? searchTerms.currentPage : 1;
        vm.pageSize = searchTerms.pageSize >= 20 ? searchTerms.pageSize : 20;
        vm.match = searchTerms.match ? searchTerms.match == 'true' ? true : false : false;
        vm.inactive = searchTerms.inactive ? searchTerms.inactive == 'true' ? true : false : false;
    }
    vm.searchedVariant = null;
    vm.canAccess = AuthService.canAccess;
    vm.mayReadStockLogistics = AuthService.canAccess('stockLogistics', 'read');
    vm.availableSubCategories = [];
    vm.availableDepartments = [];
    vm.countries = countries;
    vm.productClasses = productClasses;
    vm.currencies = currencies;
    vm.defaultCurrency = defaultCurrency;
    vm.tabSelection = {
        article: true,
        articleVariants: false,
        supplierPrices: false,
        barcodes: false,
        stocklocations: false,
        metaFields: false
    };
    vm.showStocklocationsTab = false;
    vm.tenantsWithStocklocationTab = ["vfo", "int2"];
    vm.tenantsWithoutPriceListTab = [];
    vm.location = null;
    vm.locations = [];
    vm.stocklocations = [];
    var firstTimeLoadOfPrices = true;
    vm.priceLists = [];
    vm.hasClaim = havePurchaseCostClaim();

    vm.priceListPriceDisplaySelections = [
        { type: 'salesPrice', order: 1, label: 'article.salesprice' },
        { type: 'previousPrice', order: 2, label: 'article.previousprice'}
    ];
    vm.priceListPriceDisplaySelection = vm.priceListPriceDisplaySelections[0];

    //Methods
    vm.startEdit = startEdit;
    vm.cancelEdit = cancelEdit;
    vm.getMargin = getMargin;
    vm.save = save;
    vm.initSupplierPricesGrid = initSupplierPricesGrid;
    vm.changeItemGroup = changeItemGroup;
    vm.changeVariantGroup = changeVariantGroup;
    vm.downloadArticleLabels = downloadArticleLabels;
    vm.openLabelsModal = openLabelsModal;
    vm.openItemGroupModal = openItemGroupModal;
    vm.openNewIntrastatModal = openNewIntrastatModal;
    vm.addAdditionalArticleVariants = addAdditionalArticleVariants;
    vm.isNewWithItemGroup = isNewWithItemGroup;
    vm.suppliers = [];
    vm.loadSuppliers = loadSuppliers;
    vm.changeToArticleTab = changeToArticleTab;
    vm.changeToArticleVariantsTab = changeToArticleVariantsTab;
    vm.changeToSupplierPricesTab = changeToSupplierPricesTab;
    vm.changeToBarcodesTab = changeToBarcodesTab;
    vm.changeToStocklocationsTab = changeToStocklocationsTab;
    vm.changeToPriceListsTab = changeToPriceListsTab;
    vm.changeToMetaFieldsTab = changeToMetaFieldsTab;
    vm.loadSupplierPricesGridData = loadSupplierPricesGridData;
    vm.filterSupplierRowData = filterSupplierRowData;
    vm.filterArticleVariantData = filterArticleVariantData;
    vm.calculatePurchasePrice = calculatePurchasePrice;
    vm.calculateCostPrice = calculateCostPrice;
    vm.copyToAllVisibleSupplierPrices = copyToAllVisibleSupplierPrices;
    vm.getStockLocations = getStockLocations;
    vm.updateAllArticleVariantHeights = updateAllArticleVariantHeights;
    vm.updateAllArticleVariantLengths = updateAllArticleVariantLengths;
    vm.updateAllArticleVariantWeights = updateAllArticleVariantWeights;
    vm.updateAllArticleVariantWidths = updateAllArticleVariantWidths;
    vm.updateAllArticleVariantMeursingCodes = updateAllArticleVariantMeursingCodes;
    vm.updateAllIntrastats = updateAllIntrastats;
    vm.updateAllArticleVariantCollections = updateAllArticleVariantCollections;
    vm.isSearchedVariant = isSearchedVariant;
    vm.showPriceListsTab = showPriceListsTab;
    vm.hasCurrencyConversions = hasCurrencyConversions;
    vm.productStateGo = productStateGo;
    vm.metaFieldValues = metaFieldValues;
    vm.metaFields = metaFields;
    vm.openColourChangeModal = openColourChangeModal;
    vm.dropDownFilter = dropDownFilter;

    var isAlreadyPersisting = false;

    var unsubEvent = reactEvents.fooBar.subscribe(() => {
        $scope.fooBar = "hello world";
        $scope.$digest();
      });

      var unsubSaveMetaFieldsEvent = reactEvents.saveMetaFields.subscribe((fields) => {
        ProductsApiService.upsertMetaFields(fields).then(function(response) {
        }, function(error) {
            ToasterService.showError(error.message);
        });
      });

      var unsubSaveMetaFieldValuesEvent = reactEvents.saveMetaFieldValues.subscribe((fields) => {
        ProductsApiService.upsertMetaFieldValues(article.id, fields).then(function(response) {
        }, function(error) {
            ToasterService.showError(error.message);
        });
      });
   
      $scope.$on('$destroy', () => {
        unsubEvent();
        unsubSaveMetaFieldsEvent();
        unsubSaveMetaFieldValuesEvent();
      });

    activate();

    function activate() {
        if (vm.isNewArticle) {
            vm.selectedArticleCopy.articleVariants = [];
            vm.selectedArticleCopy.isVariant = true;
            vm.selectedArticleCopy.isActive = true;

            var currentArticleCollection = _.find(vm.articleCollections, function(articleCollection) { return articleCollection.isCurrent; });
            if (currentArticleCollection) {
                vm.selectedArticleCopy.articleCollection = currentArticleCollection;
            }

            $scope.$watch(function() { return vm.selectedArticleCopy.itemGroup; }, function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (vm.selectedArticleCopy.itemGroup && vm.selectedArticleCopy.itemGroup.brand && vm.selectedArticleCopy.itemGroup.brand.company) {
                        vm.selectedArticleCopy.preferredSupplier = vm.selectedArticleCopy.itemGroup.brand.company;

                        vm.loadSuppliers();

                        if (!_.find(vm.selectedArticleCopy.suppliers, function(c) { return c.id === vm.selectedArticleCopy.preferredSupplier.id; })) {
                            vm.selectedArticleCopy.suppliers = [];
                            vm.selectedArticleCopy.suppliers.push(vm.selectedArticleCopy.preferredSupplier);
                        }
                    }
                }
            });
        }
        if (!vm.isNewArticle) {
            var articleVariants = vm.selectedArticleCopy.articleVariants;
            if (vm.filter) {
                if (articleVariants) {
                    if (!vm.searchedVariant) {
                        vm.searchedVariant = _.find(articleVariants, {'externalId': vm.filter});
                    }
                    if (!vm.searchedVariant) {
                        vm.searchedBarcode = angular.copy(vm.filter);
                        vm.searchedVariant = _.find(articleVariants, function(bc) {
                            return _.find(bc.articleVariantBarcodes, function(bc2) {
                                return String(bc2.barcode) === vm.filter;
                            });
                        });
                        vm.searchedBarcode = angular.copy(vm.filter);
                    }
                }
            }

            initArticleVariantBarcodes();
        }
        if (!_.has(vm.selectedArticle, 'descriptionShort')) {
            vm.selectedArticle['descriptionShort'] = "";
        }

        if (!vm.selectedArticle.articleType) {
            vm.selectedArticle.articleType = {};
            vm.selectedArticleCopy.articleType = {};
        }
        if (!vm.selectedArticle.intrastat) {
            vm.selectedArticle.intrastat = {};
            vm.selectedArticleCopy.intrastat = {};
        }

        resolveIntrastats();

        resolveAccounts();

        loadMainGroupData(vm.selectedArticleCopy.itemGroup);
        initSupplierPricesGrid();

        $scope.$watch(function () { return vm.selectedArticleCopy.preferredSupplier; },
        function () {
            if (vm.selectedArticleCopy.preferredSupplier && !_.find(vm.selectedArticleCopy.suppliers, function(c) { return c.id === vm.selectedArticleCopy.preferredSupplier.id; })) {
                vm.selectedArticleCopy.suppliers.push(vm.selectedArticleCopy.preferredSupplier);
            }
        });

        $scope.$watch(function () { return vm.selectedArticleCopy.isActive; },
            function () {
                if (vm.selectedArticleCopy !== undefined && !vm.selectedArticleCopy.isActive && vm.isEditing) {
                    ToasterService.showWarning($translate.instant('article.changetoinactivewarning'));
                }
            });
        $scope.$watch('vm.selectedArticleCopy.subCategory', function() {
                resolveIntrastats();
        });
        $scope.$watch('vm.selectedArticleCopy.intrastat', function(newValue, oldValue) {
            if (newValue !== oldValue) { updateAllIntrastats(oldValue, newValue); }
        });
        $scope.$watch('vm.selectedArticleCopy.articleCollection', function(newValue, oldValue) {
            if (newValue !== oldValue) { updateAllArticleVariantCollections(oldValue, newValue); }
        });

        $scope.$watch('vm.selectedArticleCopy.articleVariants.length', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                initSupplierPricesGrid();
            }
        });

        // var currentUser = null;
        // AuthService.getUser().then(function(response) {
        //     currentUser = response;
        //     var tsi = currentUser.tenant.tenantStringIdentifier.toLowerCase();
        //     if (vm.tenantsWithStocklocationTab.indexOf(tsi) !== -1) {
        //         vm.showStocklocationsTab = true;
        //     }
        //     if (vm.tenantsWithoutPriceListTab.indexOf(tsi) > -1) {
        //         vm.showPriceListsTab = false;
        //     }
        // });

        vm.showStocklocationsTab = hasSimpleWms;
        // ProductsApiService.hasSimpleWms().then(function(response) {
        //     vm.showStocklocationsTab = response;
        // });

        ProductsApiService.getLocations().then(function(response) {
            vm.locations = response;
            vm.locations.unshift({ id: 0, locationName: "Välj ett lager", locationNumber: null });
            vm.location = vm.locations[0];
        }, function(error) {
            ToasterService.showError(error.message);
        });

        //Always preload list of suppliers
        loadSuppliers();
    }

    function openColourChangeModal(articleId) {
        console.log("Selected articleId: ", articleId);
        colourChangeDialogService.showDialog(articleId);
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined) {
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read) {
            return false
        }

        return true
    }
    
    function showPriceListsTab() {
        return ProductService.canReadPrices(vm.selectedArticleCopy.links);
    }
    function loadPrices() {
        ProductsApiService.getProductPrices(vm.selectedArticleCopy.id).then(function(response) {
            vm.productPrices = response.variants;
            firstTimeLoadOfPrices = false;

            vm.priceLists = [];
            _.forEach(vm.productPrices, function(pp) {
                _.forEach(pp.priceListItems, function(pl) {
                    if (!_.find(vm.priceLists, function(o) { return o.priceListId === pl.priceListId; })) {
                        vm.priceLists.push({
                            currencyCode: pl.currencyCode,
                            priceListId: pl.priceListId,
                            priceListName: pl.priceListName,
                            priceListCode: pl.priceListCode,
                            salesChannel: pl.salesChannel
                        });
                    }
                });
            });
        }, function(error) {
            ToasterService.showError(error.message);
        });
    }

    function getStockLocations() {
        vm.stocklocations = [];
        if (vm.location.locationNumber != null) {
            // Get stocklocations from SimpleWMS
            ProductsApiService.getProductStockLocations(vm.location.locationNumber, vm.selectedArticle.id).then(function(response) {
                if (response.items.length > 0) {
                    var stocklocations = [];
                    for (var i = 0; i < response.items.length; i++) {
                        var item = response.items[i];
                        stocklocations[item.variantId] = [];
                        stocklocations[item.variantId]['stocklocation'] = item.storageLocations.join(', ');
                        stocklocations[item.variantId]['isphotographed'] = item.isPhotographed;
                    }
                    vm.stocklocations = stocklocations;
                }
            }, function(error) {
                console.log('Error fetching stock locations', error.message);
                ToasterService.showError(error.message);
            });
        }
    }

    function loadSuppliers() {
        if (vm.selectedArticleCopy.itemGroup === undefined) { return; }

        ProductsApiService.getSuppliers(vm.selectedArticleCopy.itemGroup.brand.id).then(function(response) {
            var supplierList = response.items.map(function(item) { return { id: item.id, companyName: item.name }; });
            vm.suppliers = supplierList;
        }, function(error) {
            ToasterService.showError(error.message);
        });
    }

    function isSearchedVariant(articleVariant) {
        if (!vm.searchedVariant || !articleVariant) {
            return false;
        }
        if (vm.searchedVariant.id !== articleVariant.id) {
            return false;
        }
        return true;
    }

    function updateAllArticleVariantHeights(origValue) {
        _.forEach(vm.selectedArticleCopy.articleVariants, function(articleVariant) {
            if (articleVariant.variantHeight === null) { articleVariant.variantHeight = 0; }
            if (articleVariant.variantHeight === origValue) {
                if (vm.selectedArticleCopy.productHeight === null) { vm.selectedArticleCopy.productHeight = 0; }
                articleVariant.variantHeight = vm.selectedArticleCopy.productHeight;
            }
        });
    }
    function updateAllArticleVariantLengths(origValue) {
        _.forEach(vm.selectedArticleCopy.articleVariants, function(articleVariant) {
            if (articleVariant.variantLength === null) { articleVariant.variantLength = 0; }
            if (articleVariant.variantLength === origValue) {
                if (vm.selectedArticleCopy.productLength === null) { vm.selectedArticleCopy.productLength = 0; }
                articleVariant.variantLength = vm.selectedArticleCopy.productLength;
            }
        });
    }
    function updateAllArticleVariantWeights(origValue) {
        _.forEach(vm.selectedArticleCopy.articleVariants, function(articleVariant) {
            if (articleVariant.variantWeight === null) { articleVariant.variantWeight = 0; }
            if (articleVariant.variantWeight === origValue) {
                if (vm.selectedArticleCopy.productWeight === null) { vm.selectedArticleCopy.productWeight = 0; }
                articleVariant.variantWeight = vm.selectedArticleCopy.productWeight;
            }
        });
    }
    function updateAllArticleVariantWidths(origValue) {
        _.forEach(vm.selectedArticleCopy.articleVariants, function(articleVariant) {
            if (articleVariant.variantWidth === null) { articleVariant.variantWidth = 0; }
            if (articleVariant.variantWidth === origValue) {
                if (vm.selectedArticleCopy.productWidth === null) { vm.selectedArticleCopy.productWidth = 0; }
                articleVariant.variantWidth = vm.selectedArticleCopy.productWidth;
            }
        });
    }
    function updateAllArticleVariantMeursingCodes() {
        _.forEach(vm.selectedArticleCopy.articleVariants, function(articleVariant) {
            if (articleVariant.meursingCode === null) { articleVariant.meursingCode = ''; }
            articleVariant.meursingCode = vm.meursingCode;
        });
    }
    function updateAllIntrastats(origValue, newValue) {
        _.forEach(vm.selectedArticleCopy.articleVariants, function(articleVariant) {
            if (!articleVariant.intrastat || articleVariant.intrastat.code === origValue.code) {
                articleVariant.intrastat = angular.copy(newValue);
            }
        });
    }

    function updateAllArticleVariantCollections(origValue, newValue) {
        _.forEach(vm.selectedArticleCopy.articleVariants, function (articleVariant) {
            if (articleVariant.articleCollection && articleVariant.articleCollection.id === origValue.id) {
                articleVariant.articleCollection = angular.copy(newValue);
            }
        });
    }

    function calculatePurchasePrice(purchasePrice, discountPercent) {
        var discountAmount = (purchasePrice * discountPercent / 100);
        return purchasePrice - discountAmount;
    }

    function calculateCostPrice(purchasePrice, discountPercent, standardCostAddPercent, currencyRate, shippingCost, customsPercent, otherCosts) {
        var pp = calculatePurchasePrice(purchasePrice, discountPercent);
        var ppCurrencyConverted = pp * currencyRate;
        var customsAmount = (ppCurrencyConverted + shippingCost) * (customsPercent / 100);
        var standardCostAddAmount = (ppCurrencyConverted + shippingCost + customsAmount + otherCosts) * (standardCostAddPercent / 100);

        return ppCurrencyConverted + shippingCost + customsAmount + otherCosts + standardCostAddAmount;
    }

    function hasCurrencyConversions() {
        var response = false;
        _.forEach(vm.supplierRowData, function (supplierRow) {
            if (vm.defaultCurrency.code !== supplierRow.purchasingCurrency.code) {
                response = true;
            }
        });
        return response;
    }

    function initFilters() {
        // Selected supplier filter
        vm.selectedSupplierFilter.suppliers = _.uniqBy(angular.copy(vm.selectedArticleCopy.suppliers), 'companyName');
        vm.selectedSupplierFilter.suppliers.unshift({ id: -1, companyName: $translate.instant('common.all') });
        vm.selectedSupplierFilter.selectedSupplier = vm.selectedSupplierFilter.suppliers[0];

        var variantsWithUniqueVariant1Detail = _.uniqBy(angular.copy(vm.selectedArticleCopy.articleVariants), 'variantDetail1.variantDetailName');
        vm.selectedSupplierFilter.variants1 = [];
        _.forEach(variantsWithUniqueVariant1Detail, function(v) { vm.selectedSupplierFilter.variants1.push(v.variantDetail1)});
        vm.selectedSupplierFilter.variants1.unshift({ id: -1, variantDetailName: $translate.instant('common.all') });
        vm.selectedSupplierFilter.selectedVariant1 = vm.selectedSupplierFilter.variants1[0];

        vm.selectedSupplierFilter.variants2 = [];
        var variantsWithUniqueVariant2Detail = _.uniqBy(angular.copy(vm.selectedArticleCopy.articleVariants), 'variantDetail2.variantDetailName'); 
        _.forEach(variantsWithUniqueVariant2Detail, function(v) { vm.selectedSupplierFilter.variants2.push(v.variantDetail2)});
        vm.selectedSupplierFilter.variants2.unshift({ id: -1, variantDetailName: $translate.instant('common.all') });
        vm.selectedSupplierFilter.selectedVariant2 = vm.selectedSupplierFilter.variants2[0];

        // Selected ArticleVariant filter
        vm.selectedArticleVariantFilter.variants1 = [];
        _.forEach(variantsWithUniqueVariant1Detail, function(v) { vm.selectedArticleVariantFilter.variants1.push(v.variantDetail1)});
        vm.selectedArticleVariantFilter.variants1.unshift({ id: -1, variantDetailName: $translate.instant('common.all') });
        vm.selectedArticleVariantFilter.selectedVariant1 = vm.selectedArticleVariantFilter.variants1[0];

        vm.selectedArticleVariantFilter.variants2 = [];
        _.forEach(variantsWithUniqueVariant2Detail, function(v) { vm.selectedArticleVariantFilter.variants2.push(v.variantDetail2)});
        vm.selectedArticleVariantFilter.variants2.unshift({ id: -1, variantDetailName: $translate.instant('common.all') });
        vm.selectedArticleVariantFilter.selectedVariant2 = vm.selectedArticleVariantFilter.variants2[0];
    }

    function filterSupplierRowData(row) {
        return (vm.selectedSupplierFilter.selectedSupplier.id === -1 ||
                    vm.selectedSupplierFilter.selectedSupplier.id === row.companyId) &&
               (vm.selectedSupplierFilter.selectedVariant1.id === -1 ||
                    vm.selectedSupplierFilter.selectedVariant1.id === row.variantDetail1Id) &&
               (vm.selectedSupplierFilter.selectedVariant2.id === -1 ||
                    vm.selectedSupplierFilter.selectedVariant2.id === row.variantDetail2Id);
    }
    function filterArticleVariantData(row) {
        return (vm.selectedArticleVariantFilter.selectedVariant1.id === -1 ||
                    vm.selectedArticleVariantFilter.selectedVariant1.id === row.variantDetail1.id) &&
               (vm.selectedArticleVariantFilter.selectedVariant2.id === -1 ||
                    vm.selectedArticleVariantFilter.selectedVariant2.id === row.variantDetail2.id);
    }

    function changeToArticleTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.article = true;
    }

    function changeToArticleVariantsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.articleVariants = true;
    }

    function changeToSupplierPricesTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.supplierPrices = true;
    }

    function changeToBarcodesTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.barcodes = true;
    }

    function changeToStocklocationsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.stocklocations = true;
    }

    function changeToPriceListsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.priceLists = true;
        if (firstTimeLoadOfPrices === true) {
            loadPrices();
        }
    }

    function changeToMetaFieldsTab() {
        setAllTabSelectionsToFalse();
        vm.tabSelection.metaFields = true;
    }

    function setAllTabSelectionsToFalse() {
        var keys = Object.keys(vm.tabSelection);
        _.forEach(keys, function(key) {
            vm.tabSelection[key] = false;
        });
    }

    function cancelEdit() {
        vm.selectedArticleCopy = angular.copy(vm.selectedArticle);
        initArticleVariantBarcodes();
        resetSupplierPricesGridWithData();
        vm.isEditing = false;
        vm.articleChangeCount++;
        angularEvents.isEditing.dispatch(false);
    }

    function initArticleVariantBarcodes() {
        var articleVariants = vm.selectedArticleCopy.articleVariants;
        if (articleVariants) {
            //Add empty article barcodes
            var sumCountBarcodes = 0;
            _.forEach(articleVariants, function(artVar) {
                if (artVar.articleVariantBarcodes && artVar.articleVariantBarcodes.length > sumCountBarcodes) {
                    sumCountBarcodes = artVar.articleVariantBarcodes.length;
                }
            });
            _.forEach(articleVariants, function(artVar) {
                artVar.barcodesZerofill = angular.copy(artVar.articleVariantBarcodes);
                for (var i = 0; i < sumCountBarcodes - artVar.articleVariantBarcodes.length; i++) {
                    artVar.barcodesZerofill.push({ barcode: '', id: '' });
                }
            });
        }
    }

    function resolveIntrastats() {

        var intrastats = [];

        if (vm.selectedArticleCopy.itemGroup) {

            var mainGroup = vm.selectedArticleCopy.itemGroup.mainGroup;
            var subCategory = vm.selectedArticleCopy.subCategory;

            if (mainGroup && mainGroup.intrastats) {
                intrastats = _.unionBy(intrastats, mainGroup.intrastats, 'id');
            }
            if (subCategory && subCategory.intrastats) {
                intrastats = _.unionBy(intrastats, subCategory.intrastats, 'id');
            }

            if (!vm.selectedArticleCopy.intrastat ||  _.filter(intrastats, {id: vm.selectedArticleCopy.intrastat.id}).length === 0) {
                selectDefaultIntrastat();
            }
        }

        intrastats.forEach(function(intrastat) {
            if (intrastat.internalDescription && intrastat.internalDescription.length > 15) {
                intrastat.internalDescription = intrastat.internalDescription.substr(0, 15) + '...';
            }
        }, this);

        vm.intrastats = intrastats;
    }

    function resolveAccounts() {
        if (vm.isNewArticle && vm.selectedArticleCopy.itemGroup) {
            var mainGroup = vm.selectedArticleCopy.itemGroup.mainGroup;

            vm.selectedArticleCopy.discountAccount = mainGroup.discountAccount;
            vm.selectedArticleCopy.salesAccount = mainGroup.salesAccount;
        }
    }

    function startEdit() {
        vm.isEditing = true;

        angularEvents.isEditing.dispatch(true);

        //Make sure the preferredSupplier always is a selected supplier
        if (vm.selectedArticleCopy.preferredSupplier !== undefined) {
            var prefSupp = _.filter(vm.selectedArticleCopy.suppliers, { id: vm.selectedArticleCopy.preferredSupplier.id });

            if (vm.selectedArticleCopy.suppliers.length === 0 || prefSupp.length === 0) {
                vm.selectedArticleCopy.suppliers.push(vm.selectedArticleCopy.preferredSupplier);
            }
        }

        if (!vm.isNewArticle) {
            resetSupplierPricesGridWithData();

            var itemGroup = vm.selectedArticleCopy.itemGroup;
            ProductsApiService.getVariant(itemGroup.mainGroup.variant2.id).then(function (variant) {
                vm.variant2 = variant;
            });

        }

        if (vm.isNewArticle) {
            resolveAccounts();
        }
    }

    function getMargin() {
        var vatMultiplier = vm.selectedArticleCopy.vat ? 1 / (vm.selectedArticleCopy.vat.vatRate + 1) : 1;
        var salesPrice = vm.selectedArticleCopy.salesPrice || 0;
        var purchaseCost = vm.selectedArticleCopy.purchaseCost || 0;

        var brv = ((salesPrice * vatMultiplier) - purchaseCost) / (salesPrice * vatMultiplier);

        if ((!salesPrice && !purchaseCost) || !salesPrice) {
            return 0;
        }

        return brv.toFixed(2);
    }

    function save() {
        angularEvents.saveArticle.dispatch();
        angularEvents.isEditing.dispatch(false);
        if (vm.isNewArticle) {
            return saveNewArticle();
        } else {
            return updateArticle();
        }
    }

    function updateArticle() {
        if (isAlreadyPersisting) { return; }
        isAlreadyPersisting = true;

        var deferred = $q.defer();
        vm.validationErrors = [];

        _.forEach(vm.selectedArticleCopy.articleVariants, function (articleVariant) {
            if (articleVariant.salesPrice === "") {
                articleVariant.salesPrice = 0;
            }
            if (articleVariant.purchaseCost === "") {
                articleVariant.purchaseCost = 0;
            }
        });

        var fields = [
            'salesPrice',
            'purchaseCost',
            'subCategory',
            'alternativeArticleNumber',
            'articleCollection',
            'articleVariants',
            'articleName',
            'vat',
            'descriptionShort',
            'descriptionLong',
            'isCurrent',
            'previousPrice',
            'articleType',
            'salesChannels',
            'isActive',
            'intrastat',
            'department',
            'countryOfOrigin',
            'productLength',
            'productWidth',
            'productHeight',
            'productWeight',
            'minPurchaseQty',
            'preferredSupplier',
            'suppliers',
            'articleClass',
            'discountAccount',
            'salesAccount',
            'storage',
            'itemGroup',
            'variantGroup2'
        ];

        _.forEach(fields, function (field) {
            if (article[field] === undefined) {
                article[field] = null;
            }
        });

        var changedData = HelperService.getChangedData(article, vm.selectedArticleCopy, fields);

        if (!_.isEmpty(changedData)) {
            loadSpinnerService.start('mainSpinner');
            ProductsApiService.updateProduct(article.id, changedData).then(function (response) {
                vm.selectedArticleCopy = angular.copy(response);
                vm.selectedArticle = angular.copy(response);
                article = angular.copy(response);

                vm.supplierRowData = loadSupplierPricesGridData();
                initFilters();
                initArticleVariantBarcodes();

                vm.articleChangeCount++;

                vm.isEditing = false;
                deferred.resolve();
            }, function (error) {
                deferred.resolve("");
                if (error.errors) {
                    vm.validationErrors = error.errors;
                }
                ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
            }).finally(function () {
                loadSpinnerService.stop('mainSpinner');
                isAlreadyPersisting = false;
            });
        } else {
            deferred.resolve();
            isAlreadyPersisting = false;
        }

        return deferred.promise;
    }

    function saveNewArticle() {
        if (isAlreadyPersisting) { return; }
        isAlreadyPersisting = true;

        var deferred = $q.defer();
        vm.validationErrors = [];
        loadSpinnerService.start('mainSpinner');
        if (!vm.selectedArticleCopy.isVariant) {
            vm.selectedArticleCopy.articleVariants = [
                {
                    articleCollection: vm.selectedArticleCopy.articleCollection,
                    salesPrice: vm.selectedArticleCopy.salesPrice,
                    previousPrice: vm.selectedArticleCopy.previousPrice,
                    purchaseCost: vm.selectedArticleCopy.purchaseCost,
                    variantDetail1: { variantDetailName: "--" },
                    variantDetail2: { variantDetailName: "--" },
                    supplierPrices: vm.selectedArticleCopy.supplierPrices
                }
            ];
        }
        _.forEach(vm.selectedArticleCopy.articleVariants, function (articleVariant) {
            if (articleVariant.salesPrice === "") {
                articleVariant.salesPrice = 0;
            }
            if (articleVariant.purchaseCost === "") {
                articleVariant.purchaseCost = 0;
            }
        });

        ProductsApiService.createProduct(vm.selectedArticleCopy).then(function (response) {
            vm.selectedArticleCopy = angular.copy(response);
            vm.selectedArticle = angular.copy(response);
            article = angular.copy(response);

            vm.supplierRowData = loadSupplierPricesGridData();
            initFilters();
            initArticleVariantBarcodes();

            vm.articleChangeCount++;

            $state.go('product.articles.article', { articleId: response.id });
        }, function (error) {
            deferred.resolve("");
            if (error.errors) {
                vm.validationErrors = error.errors;
            }
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
            isAlreadyPersisting = false;
        });
        return deferred.promise;
    }

    function changeItemGroup(itemGroup) {
        if (itemGroup) {
            vm.selectedArticleCopy.subCategory = {};
            loadItemGroupData(itemGroup);
        }
    }

    function loadItemGroupData(itemGroup) {
        ProductsApiService.getItemGroup(itemGroup.id).then(function (result) {
            vm.selectedArticleCopy.itemGroup = result;

            loadMainGroupData(result, true);
        });
    }
    function loadMainGroupData(itemGroup, setDefaults) {
        if (itemGroup) {
            ProductsApiService.getMainGroup(itemGroup.mainGroup.id).then(function (result) {
                vm.selectedArticleCopy.itemGroup.mainGroup = result;

                vm.availableSubCategories = _.sortBy(result.subCategories, function (subCategory) {
                    return subCategory.subCategoryCode;
                });

                vm.availableDepartments = _.sortBy(result.departments, function (department) {
                    return department.departmentCode;
                });
                resolveIntrastats();

                if (setDefaults) {
                    selectDefaultDepartment(result.departments);
                    selectDefaultSubCatgory(result.subCategories);
                    selectDefaultAccounts(result);
                }

                ProductsApiService.getVariant(result.variant2.id).then(function (variant) {
                    vm.variant2 = variant;
                    selectDefaultVat();
                    selectDefaultIntrastat();
                    selectDefaultVariantGroup();
                    selecteDefaultIsVariant();
                    selectDefaultSalechannels(itemGroup);
                });
            });
        }
    }

    function changeVariantGroup() {
    }
    // Init SupplierPrice
    function initSupplierPricesGrid() {
        vm.supplierRowData = loadSupplierPricesGridData();
        initFilters();
        if(vm.supplierRowData === undefined || vm.supplierRowData.length === 0){
            vm.supplierRowData = initSupplierPricesGridData();
        }
    
    }

    function initSupplierPricesGridData(){

        var supplierPricesRowdata = [];
        _.forEach(vm.selectedArticleCopy.articleVariants,function(artVar){
            _.forEach(artVar.supplierPrices,function(supplierPriceRow){
                supplierPricesRowdata.push(supplierPriceRow);          
             })          
        })
        if(supplierPricesRowdata === undefined){
            supplierPricesRowdata = [];
        }

        return supplierPricesRowdata;
    }
    function loadSupplierPricesGridData() {
        var rows = [];

        var companyRows = _.sortBy(vm.selectedArticleCopy.suppliers);
        
        _.forEach(companyRows, function(comp) {
            _.forEach(vm.selectedArticleCopy.articleVariants, function (variantRowValues) {
                if (variantRowValues.supplierPrices === undefined) {
                    variantRowValues.supplierPrices = [];
                }
                var filteredRows = _.filter(variantRowValues.supplierPrices, { companyId: comp.id });
                if (filteredRows.length === 0) {
                    var newRow = {};
                    newRow.articleVariantId = variantRowValues.id;
                    newRow.alternativeProductNumber = "";
                    newRow.purchaseCost = 0;
                    newRow.discountPercent = 0;
                    newRow.standardCostAddPercent = 0;
                    newRow.companyId = comp.id;
                    newRow.externalId = variantRowValues.externalId;
                    newRow.variantDetail1Id = variantRowValues.variantDetail1.id;
                    newRow.variantDetail1Name = variantRowValues.variantDetail1.variantDetailName;
                    newRow.variantDetail2Id = variantRowValues.variantDetail2.id;
                    newRow.variantDetail2Name = variantRowValues.variantDetail2.variantDetailName;
                    newRow.companyName = comp.companyName;
                    if (comp.purchasingCurrency) {
                        newRow.purchasingCurrency = comp.purchasingCurrency;
                    } else {
                        newRow.purchasingCurrency = defaultCurrency;
                    }
                    variantRowValues.supplierPrices.push(newRow);
                    rows.push(newRow);
                } else {
                    var existingRow = filteredRows[0];
                    existingRow.articleVariantId = variantRowValues.id;
                    existingRow.companyId = comp.id;
                    existingRow.externalId = variantRowValues.externalId;
                    existingRow.variantDetail1Id = variantRowValues.variantDetail1.id;
                    existingRow.variantDetail1Name = variantRowValues.variantDetail1.variantDetailName;
                    existingRow.variantDetail2Id = variantRowValues.variantDetail2.id;
                    existingRow.variantDetail2Name = variantRowValues.variantDetail2.variantDetailName;
                    existingRow.companyName = comp.companyName;
                    if (!existingRow.purchasingCurrency) {
                        if (comp.purchasingCurrency) {
                            existingRow.purchasingCurrency = comp.purchasingCurrency;
                        } else {
                            existingRow.purchasingCurrency = defaultCurrency;
                        }
                    }
                    rows.push(existingRow);
                }
            });
        });

        return rows;
    }

    function resetSupplierPricesGridWithData() {
        vm.supplierRowData = loadSupplierPricesGridData();
        initFilters();
    }

    function selectDefaultVat() {
        if (vm.selectedArticleCopy.itemGroup && vm.selectedArticleCopy.itemGroup.vat) {
            var vatId = vm.selectedArticleCopy.itemGroup.vat.id;
            var vat = _.find(vm.vats, function (vat) {
                return vat.id === vatId;
            });
            vm.selectedArticleCopy.vat = vat;
        }
    }

    function selectDefaultSalechannels(itemGroup) {
        if (vm.isNewArticle) {
            loadSpinnerService.start('mainSpinner', { message: $translate.instant('article.checkingSalesChannels') });
            ProductsApiService.getItemGroup(itemGroup.id).then(function(response) {
                itemGroup = response;

                var salesChannels = _.clone(vm.salesChannels);

                if (itemGroup.mainGroup && itemGroup.mainGroup.salesChannels && itemGroup.mainGroup.salesChannels.length > 0) {
                    salesChannels = _.intersectionBy(salesChannels, itemGroup.mainGroup.salesChannels, 'id');
                }

                if (itemGroup.brand && itemGroup.brand.salesChannels && itemGroup.brand.salesChannels.length > 0) {
                    salesChannels = _.intersectionBy(salesChannels, itemGroup.brand.salesChannels, 'id');
                }

                vm.selectedArticleCopy.salesChannels = salesChannels;
            }, function(error) {
                ToasterService.showError(error.message);
            }).finally(function () {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function selectDefaultDepartment(departments) {
        if (departments.length === 1) {
            vm.selectedArticleCopy.department = departments[0];
        }
    }

    function selectDefaultSubCatgory(subCategories) {
        if (subCategories.length === 1) {
            vm.selectedArticleCopy.subCategory = subCategories[0];
        }
    }

    function selectDefaultAccounts(mainGroup) {
        if (mainGroup.discountAccount) {
            vm.selectedArticleCopy.discountAccount = mainGroup.discountAccount;
        }
        if (mainGroup.salesAccount) {
            vm.selectedArticleCopy.salesAccount = mainGroup.salesAccount;
        }
    }

    function selecteDefaultIsVariant() {
        if (vm.selectedArticleCopy.itemGroup && vm.selectedArticleCopy.itemGroup.mainGroup) {
            vm.selectedArticleCopy.isVariant = vm.selectedArticleCopy.itemGroup.mainGroup.isVariant;
        }
    }

    function selectDefaultIntrastat() {
        if (!vm.isEditing) {
            return;
        }

        //If exists in both
        if (vm.selectedArticleCopy.itemGroup.mainGroup && vm.selectedArticleCopy.subCategory) {
            var intrastats = _.intersectionBy(vm.selectedArticleCopy.itemGroup.mainGroup.intrastats, vm.selectedArticleCopy.subCategory.intrastats, 'id');
            if (intrastats.length === 1) {
                vm.selectedArticleCopy.intrastat = intrastats[0];
                return;
            }
        }

        //If only one in maingroup
        if (vm.selectedArticleCopy.itemGroup.mainGroup && vm.selectedArticleCopy.itemGroup.mainGroup.intrastats && vm.selectedArticleCopy.itemGroup.mainGroup.intrastats.length === 1) {
            vm.selectedArticleCopy.intrastat = vm.selectedArticleCopy.itemGroup.mainGroup.intrastats[0];
            return;
        }

        //If only one in subCategory
        if (vm.selectedArticleCopy.subCategory && vm.selectedArticleCopy.subCategory.intrastats && vm.selectedArticleCopy.subCategory.intrastats.length === 1) {
            vm.selectedArticleCopy.intrastat = vm.selectedArticleCopy.subCategory.intrastats[0];
            return;
        }
    }

    function selectDefaultVariantGroup() {
        if (vm.selectedArticleCopy.itemGroup.variantGroup2 !== undefined && vm.selectedArticleCopy.itemGroup.variantGroup2 !== null) {
            var groupId = vm.selectedArticleCopy.itemGroup.variantGroup2.id;
            var group = _.find(vm.variant2.variantGroups, function (variantGroup) {
                return variantGroup.id === groupId;
            });
            vm.selectedArticleCopy.variantGroup2 = group;
            changeVariantGroup();
        }
    }

    function downloadArticleLabels() {
        ProductsApiService.downloadArticleLabels(vm.selectedArticle.id);
    }

    function openLabelsModal() {
        ArticleLabelsPrintDialogService.showDialog(vm.selectedArticle.id);
    }

    function openItemGroupModal() {
        ArticleChangeItemGroupDialogService.showDialog(vm.selectedArticle.id, itemGroups).then(function(response){
            if(response)
                $state.go($state.current.name,{},{reload: $state.current.name});
        });
    }

    function openNewIntrastatModal(articleVariant) {
        var articleVariantId = null;
        if (articleVariant) { articleVariantId = articleVariant.id; }
        ArticleNewIntrastatDialogService.showDialog(vm.selectedArticleCopy.id, articleVariantId).then(function(response) {
            if (response) {
                vm.selectedArticleCopy.itemGroup.mainGroup.intrastats = response.itemGroup.mainGroup.intrastats;
                if (response.articleVariants.length === 1) {
                     articleVariant.intrastat = response.articleVariants[0].intrastat;
                } else {
                    vm.selectedArticleCopy.intrastat = response.intrastat;
                }
            }
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
        });
    }

    function addAdditionalArticleVariants() {
        var newArticleVariants = createMissingArticleVariants(vm.selectedArticleCopy.variantGroup2, vm.selectedArticleCopy.articleVariants);

        _.forEach(newArticleVariants, function (articleVariant) {
            vm.selectedArticleCopy.articleVariants.push(articleVariant);
        });

        vm.articleChangeCount++;
    }

    function createMissingArticleVariants(variantGroup, articleVariants) {
        var newArticleVariants = [];

        var allVariant1Details = [];
        var allVariant2Details = variantGroup.variantDetails;
        var missingVariantCombinations = [];

        _.forEach(articleVariants, function(av) {
            if (!_.find(allVariant1Details, function(vd1) { return vd1.id === av.variantDetail1.id; })) {
                allVariant1Details.push(av.variantDetail1);
            }
        });

        _.forEach(allVariant1Details, function(vd1) {
            _.forEach(allVariant2Details, function(vd2) {
                if (!_.find(articleVariants, function(av) { return av.variantDetail1.id === vd1.id && av.variantDetail2.id === vd2.id; })) {
                    missingVariantCombinations.push({variantDetail1: vd1, variantDetail2: vd2});
                }
            });
        });

        _.forEach(missingVariantCombinations, function(vc) {
            var newArticleVariant = {};
            newArticleVariant['articleCollection'] = {};
            newArticleVariant['articleVariantBarcodes'] = [];
            newArticleVariant['purchaseCost'] = 0;
            newArticleVariant['salesPrice'] = 0;
            newArticleVariant['variantDetail1'] = vc.variantDetail1;
            newArticleVariant['variantDetail2'] = vc.variantDetail2;
            newArticleVariant['articleVariantPrices'] = [];
            newArticleVariants.push(newArticleVariant);
        });

        return newArticleVariants;
    }

    function copyToAllVisibleSupplierPrices(sourceRow) {
        _.forEach(vm.supplierRowData, function(targetRow) {
            if (!filterSupplierRowData(targetRow) || sourceRow === targetRow) {
                return;
            }
            targetRow.purchasingCurrency = sourceRow.purchasingCurrency;
            targetRow.purchasePrice = sourceRow.purchasePrice;
            targetRow.discountPercent = sourceRow.discountPercent;
            targetRow.standardCostAddPercent = sourceRow.standardCostAddPercent;

            targetRow.shippingCost = sourceRow.shippingCost;
            targetRow.customsPercent = sourceRow.customsPercent;
            targetRow.otherCosts = sourceRow.otherCosts;

        });
    }

    function isNewWithItemGroup() {
        return !vm.selectedArticleCopy || !vm.selectedArticleCopy.itemGroup || !vm.selectedArticleCopy.itemGroup.id || vm.selectedArticleCopy.itemGroup.id <= 0;
    }

    function productStateGo(stringState) {
        $state.go(stringState, 
            {
                articleId: vm.selectedArticle.id,
                filter: searchTerms.filter,
                currentPage: searchTerms.currentPage,
                pageSize: searchTerms.pageSize,
                inactive: searchTerms.inactive,
                match: searchTerms.match
            },
            {reload:true}
        );
    }

    function dropDownFilter(query) {
        return GenericComponentService.getSelectFilter(query, vm.filterBy);
    }
}

angular
    .module('product.articles.article', [])
    .config(stateConfig)
    .controller('ArticleController', ArticleController);
